<script setup lang="ts">
const emit = defineEmits<{
  (e: 'done'): void;
}>();

function done() {
  emit('done');
}

const { staticUrl } = useRuntimeConfig().public;
</script>

<template>
  <div class="successfully-appointed-screen">
    <NuxtImg
      format="webp"
      :width="256"
      :src="`${staticUrl}/images/icons/appointed.png`"
    />
    <div class="successfully-appointed-screen__text">
      <div class="successfully-appointed-screen__title">
        Вы успешно записаны!
      </div>
      <div class="successfully-appointed-screen__subtitle">
        Мы отправим вам СМС с подтверждением и деталями записи
      </div>
    </div>
    <AppButton fluid @click="done">Отлично</AppButton>
  </div>
</template>

<style scoped lang="scss">
.successfully-appointed-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  &__text {
    text-align: center;
  }

  &__title {
    font-size: 32px;
    font-weight: 700;
  }

  &__subtitle {
    color: var(--app-color-black-secondary);
    font-size: 16px;
  }
}
</style>
